import FileDownloadApi from './FileDownloadApi';
import HttpService from './HttpService';

const VoyageReportsApi = HttpService('/api/voyagereports/');
const doPost = (action, data) => VoyageReportsApi.post(action, data);
const doGet = (url) => VoyageReportsApi.get(url);
const doDelete = (url) => VoyageReportsApi.delete(url);


export default {
  getVoyageReports(activeSiteId) {
    const queryString = `activeSiteId=${activeSiteId}`;
    const apiAction = 'GetVoyageReportsForUser';
    const fullUrl = queryString ? `${apiAction}?${queryString}` : apiAction;
    return doGet(fullUrl);
  },
  getVoyageReportDetails(voyageReportId) {
    const apiAction = 'GetVoyageReportById';
    const fullUrl = `${apiAction}?id=${voyageReportId}`;
    return doGet(fullUrl);
  },
  createVoyageReport(report) {
    return doPost('CreateVoyageReport', report);
  },
  updateVoyageReport(updateData) {
    return doPost('UpdateVoyageReport', updateData);
  },
  deleteVoyageReport(id) {
    const apiAction = 'DeleteVoyageReport';
    const fullUrl = `${apiAction}?id=${id}`;
    return doDelete(fullUrl);
  },
  getVoyageReportAsExcelFile(voyageReportId) {
    const fullUrl = `voyagereports/GetVoyageReportAsExcelFile?voyageReportId=${voyageReportId}`;
    return FileDownloadApi().get(fullUrl);
  },
};
